import ApiService from '../_shared/api/apiService';
import { COOKIES } from '../_shared/constants/cookies';
import FEATURE_FLAGS from '../_shared/constants/featureFlags';
import Singleton from '../Singleton';
import ROUTES from '../components/Routes/constants';
import { httpCodes } from '../_shared/constants/httpMethods';
import { expireCookie, getCookie } from '../_shared/utils/cookies';
import { localStorageService } from './StorageService';
import IndexDBStoreService from './IndexDBStoreService';
import OktaAuthManagementService from './OktaAuthManagementService';

export default class AuthService extends Singleton<AuthService> {
  static refreshTokens = async () => {
    const client = await ApiService();
    try {
      const response = await client.apis.auth.refresh({
        request: {
          refreshToken: getCookie(COOKIES.REFRESH_TOKEN)
        }
      });
      if (response && response.status === httpCodes.UNAUTHORIZED) {
        // Refresh token call failed, take user back
        window.location.replace(ROUTES.TR4_ENDPOINT);
        return null;
      }
      return response;
    } catch (exp) {
      // Refresh token call failed, take user back
      window.location.replace(ROUTES.TR4_ENDPOINT);
      return null;
    }
  };

  static clearLocalStorage = () => {
    localStorageService.clear();
  };

  static clearSessionStorage = () => {
    sessionStorage.clear();
  };

  static clearIndexDBStorage = async () => {
    IndexDBStoreService.clearStore();
  };

  static clearCookies = () => {
    const KEYS = {
      ...COOKIES,
      ...FEATURE_FLAGS
    };

    Object.keys(KEYS).forEach(key => expireCookie(KEYS[key]));
  };

  static clearStorage = async () => {
    await this.clearIndexDBStorage();
    this.clearLocalStorage();
    this.clearSessionStorage();
  };

  static logout = async () => {
    const client = await ApiService();
    const logout = await client.apis.auth.logout();

    return logout;
  };

  static handlePostLogout = async () => {
    await this.clearStorage();
    this.clearCookies();
    await OktaAuthManagementService.get().logoutOktaSession();
  };
}
